import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-slideview', 'back', 'Back');
